import React from 'react';
import PropTypes from 'prop-types';

const ComponentWrapper = Component => {
  // eslint-disable-next-line
  class PureComponent extends React.PureComponent {
    static propTypes = {
      forwardRef: PropTypes.object,
    };

    static defaultProps = {
      forwardRef: null,
    };

    render() {
      const { forwardRef, ...others } = this.props;

      return <Component ref={forwardRef} {...others} />;
    }
  }
  const ForwardRef = (props, ref) => <PureComponent forwardRef={ref} {...props} />;
  const name = Component.displayName || Component.name;
  ForwardRef.displayName = `withContext(${name})`;

  return React.forwardRef(ForwardRef);
};

// get @withContext
export const createWithContext = Context => getValues => Component => {
  const WithContextComponent = ComponentWrapper(Component);
  // eslint-disable-next-line
  return React.forwardRef((props, ref) => (
    <Context.Consumer>
      {context => <WithContextComponent {...props} ref={ref} {...getValues(context)} />}
    </Context.Consumer>
  ));
};

const _createProvider = (setProvider, Provider, initStates) => {
  // eslint-disable-next-line
  class ContextProvider extends React.PureComponent {
    static propTypes = {
      children: PropTypes.any,
    };

    static defaultProps = {
      children: null,
    };

    constructor(props, context) {
      super(props, context);
      this.state = initStates;
      setProvider && setProvider(this);
    }

    render() {
      return <Provider value={this.state}>{this.props.children}</Provider>;
    }
  }
  return ContextProvider;
};

// create context
export const createContext = (initStates, actionCreators = {}) => {
  const _provider = {
    state: initStates,
    setState: () => {},
  };
  const setProvider = _this => {
    _provider.setState = (state, cb) => {
      const nState = { ..._provider.state, ...state };

      _this.setState(state, () => {
        _provider.state = nState;
        cb && cb();
      });
    };
  };

  const context = React.createContext(initStates);
  const Provider = _createProvider(setProvider, context.Provider, initStates);
  const withContext = createWithContext(context);

  const actions = Object.keys(actionCreators).reduce((res, k) => {
    res[k] = (...args) => {
      let newState = actionCreators[k](...args);
      if (typeof newState === 'function') {
        newState = newState({ state: _provider.state, actions });
      }

      if (!newState) return Promise.resolve();

      // promise
      if (newState.then) {
        return newState.then(s => {
          _provider.setState(s);

          return s;
        });
      }

      _provider.setState(newState);
      return Promise.resolve(newState);
    };

    return res;
  }, {});

  return {
    Provider,
    withContext,
    actions,
  };
};

export const headerContext = React.createContext({});

export default {
  createWithContext,
};
